/** True on touch-first devices (phone/tablet). Missing matchMedia = not touch. */
export function isCoarsePointer() {
  try {
    return typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && Boolean(window.matchMedia('(pointer: coarse)').matches);
  } catch {
    return false;
  }
}

export default isCoarsePointer;
